var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 1.05884V15.8824C23.9991 16.4439 23.7797 16.9823 23.3896 17.3806L14.087 7.9412L13.9409 7.71354L24.0001 1.05884Z",
    fill: "#F6B445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 17.3806C22.9971 17.7764 22.4664 17.999 21.913 18H2.08701C1.53361 17.999 1.003 17.7764 0.610474 17.3806L9.91308 7.94116L10.0435 7.73469L12.0001 8.99997L13.9409 7.7135L14.087 7.94116L23.3896 17.3806Z",
    fill: "#F6A645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0435 7.73469L9.91306 7.94116L0.610443 17.3806C0.220362 16.9823 0.000987654 16.4439 9.3945e-06 15.8823V2.11765C-0.000626474 1.90404 0.0310202 1.69156 0.0939223 1.48767L0.521764 1.58823L10.0435 7.73469Z",
    fill: "#F6B445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 1.05881L13.9408 7.71351L12 8.99998L10.0435 7.7347L0.521714 1.58823L0.0938721 1.48763C0.365681 0.602536 1.17328 -0.000248085 2.08693 7.65959e-08H21.3913C23.4782 7.65959e-08 23.9999 1.05881 23.9999 1.05881Z",
    fill: "#FED049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.457b23e768faf5eb0822c86828f71ffb.svg";
export { ForwardRef as ReactComponent };